import React from 'react'
import { Outlet } from 'react-router-dom'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Navigation from './Navigation/Navigation'
import { useOktaAuth } from '@okta/okta-react'
import { CustomUserClaims, UserClaims } from '@okta/okta-auth-js'
import { usePurple } from './PurpleContext'
import { PurpleUser } from '../data/interfaces'

const mdTheme = createTheme({
  palette: {
    primary: {
      main: '#432B8D'
    },
    secondary: {
      main: '#007FAA'
    },
    warning: {
      main: '#ffdb5e'
    }
  }
})

const AppLayout = () => {
  const { oktaAuth, authState } = useOktaAuth()
  const { user, setUser } = usePurple()

  React.useEffect(() => {
    if (authState?.isAuthenticated && !user) {
      oktaAuth.token
        .getUserInfo()
        .then((user: UserClaims<CustomUserClaims>) => {
          setUser({
            email: user?.email ?? '',
            emailVerified: user.emailVerified,
            familyName: user.familyName,
            givenName: user.givenName,
            locale: user?.locale ?? '',
            name: user?.name ?? '',
            preferredUsername: user.preferredUsername,
            sub: user.sub,
            updatedAt: user.updatedAt,
            zoneinfo: user.zoneinfo
          } as PurpleUser)
        })
    }
  }, [authState])

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Navigation />
        <Box
          component='main'
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto'
          }}
        >
          <Toolbar />
          <Outlet />
        </Box>
      </Box>
    </ThemeProvider>
  )
}

export default AppLayout
